import { useEffect } from "react";
import { Event } from "consts/auth";
import { publish } from "util/custom-event";
import useAuthActions from "features/auth/useActions";
import { revokeAuthData, setAuthData } from "features/auth/helpers";
import type { AuthResponse } from "features/auth/types";
import type { Credentials } from "ui/forms/Auth";

export default function useLogin() {
    const { login } = useAuthActions();

    useEffect(revokeAuthData, []);

    return async ({ email, password }: Credentials.Credentials) => {
        const userCredentials = {
            email,
            password
        };

        const [request] = login(userCredentials);

        const response = (await request) as AuthResponse;

        // Persist the token before publishing GetUser. Redux also stores the
        // response, but the custom event is synchronous and the follow-up
        // request must never race the storage update.
        setAuthData({
            ...response.data,
            timestamp: Date.now()
        });

        publish(
            response.data.twoFactorAuth
                ? Event.Redirect2FA
                : Event.GetUser,
            {
                ...userCredentials,
                response
            }
        );
    };
};
